export default __webpack_public_path__ + "static/media/punainen_logo2.d0786f1f.webp";